import style from './index.module.scss';
import React from 'react';
import {SortOrder} from 'antd/es/table/interface';
import {ClassType, FunctionListItem, getFunctionPage} from '../service';
import dayjs from 'dayjs';
import OverLengthColumn from '../Components/OverLengthColumn';
import MultiLineColumn from '../Components/MultiLineColumn';
import useTable from '../../../Utils/Hooks/useTable';
import TableRender, {ProColumnsType} from 'table-render';

export default function PageMethod() {
    const sortDirections: SortOrder[] = ['descend', 'ascend'];

    const {tableInit} = useTable(getFunctionPage, {});

    const columns: ProColumnsType<FunctionListItem> = [
        {
            title: '序号',
            dataIndex: 'index',
            align: 'center',
            render: (text, item, index) => index + 1,
        },
        {
            title: '服务名称及编码',
            dataIndex: 'code',
            align: 'left',
            render: (text: string, record: FunctionListItem) => (
                <MultiLineColumn name={record.name} no={text} />
            ),
        },
        {
            title: '分类',
            dataIndex: 'className',
            align: 'center',
        },
        {
            title: '说明',
            dataIndex: 'description',
            align: 'center',
            render: (text: string) => (
                <OverLengthColumn value={text} width={200} />
            ),
        },
        {
            title: '创建时间',
            dataIndex: 'createTime',
            align: 'center',
            render: (text: string) => dayjs(text).format('YY-MM-DD HH:mm:ss'),
            sortDirections: sortDirections,
            sorter: (a, b) => dayjs(a.createTime).diff(b.createTime),
        },
    ];

    const schema = {
        type: 'object',
        labelWidth: 130,
        properties: {
            name: {
                title: '名称及编号',
                type: 'string',
            },
            classType: {
                title: '分类',
                type: 'string',
                widget: 'select',
                props: {
                    options: [
                        {label: '全部', value: ''},
                        {label: '系统内置', value: ClassType.System},
                        {label: '自定义添加', value: ClassType.Other},
                    ],
                },
            },
        },
    };

    return (
        <div className={style.root}>
            <TableRender
                columns={columns}
                rowKey="id"
                search={{schema}}
                {...tableInit()}
            />
        </div>
    );
}
